import Network from 'shared/libraries/network';
import CONFIG from 'shared/constants/config';

class OwnRespondentInviteModel extends Network {
  constructor(baseURL: string, timeout = 120000) {
    super(baseURL, timeout);
  }

  //GET
  async getInviteCompany<T>(hash: string): Promise<T> {
    return this.send('get', `/own_respondents/company`, { params: { hash } });
  }

  //POST
  async postInviteAccept<T>(own_respondents_link_hash: string): Promise<T> {
    return this.send('post', `/own_respondents/invite/accept`, {
      own_respondents_link_hash,
    });
  }
}

const baseUrl: string = CONFIG.REACT_APP_API_BASE_URL as string;
const ownRespondentInviteModel = new OwnRespondentInviteModel(baseUrl);
export default ownRespondentInviteModel;
